/* eslint-disable react/prop-types */
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

// redux imports start
import { Provider } from "react-redux";
import configureStore from "store";
// redux imports stop

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import Reset from "layouts/Reset.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.7.0";
// GHBank style sheet
import "ghbank-style.css";

const hist = createBrowserHistory();

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("sessionP") !== null ? (
        <Component {...props} />
      ) : (
        <Redirect to="/auth" />
      )
    }
  />
);

const AuthenRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("sessionP") !== null ? (
        <Redirect to="" />
      ) : (
        <Component {...props} />
      )
    }
  />
);

const ResetPasswordRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("sessionP") !== null ? (
        <Redirect to="/auth" />
      ) : (
        <Component {...props} />
      )
    }
  />
);

ReactDOM.render(
  <Provider store={configureStore()}>
    <Router history={hist} basename="/">
      <Switch>
        <ResetPasswordRoute path="/reset" component={Reset} />
        <AuthenRoute path="/auth" component={AuthLayout} />
        <PrivateRoute path="" component={AdminLayout} />
        {localStorage.getItem("sessionP") !== null ? (
          <Redirect from="/" to="/dashboard" />
        ) : (
          <Redirect from="/" to="/auth/login" />
        )}
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
